export default __webpack_public_path__ + "static/media/Xmas2.8059c94e.jpg";